import { DatePicker } from '../../../ClickableField/ClickableField';
import moment from 'moment';
import React from 'react';

const NextMeetingDateControl = props => {
  const { nextMeetingDate, onChange, onClose, className } = props;

  return (
    <DatePicker
      className={`${className ? className : ''}`}
      onClose={onClose}
      name="nextMeetingDate"
      format="DD-MMM-YYYY"
      disablePast={true}
      value={nextMeetingDate ? moment(nextMeetingDate) : null}
      onChange={onChange}
      slotProps={{
        field: { clearable: true }
      }}
    />
  );
};

export default NextMeetingDateControl;
